import React from 'react';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

export function Dialog({ open, onClose, title, children }: DialogProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/60"
        onClick={onClose}
      />
      <div
        className="relative z-10 w-full max-w-md rounded-xl border border-tg-border p-6 shadow-2xl"
        style={{ background: 'var(--tg-bg-secondary)' }}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-base font-semibold text-tg-text">{title}</h2>
          <button
            onClick={onClose}
            className="text-tg-text-secondary hover:text-tg-text transition-colors text-xl leading-none"
          >
            ×
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
